// src/components/ImageModal.jsx
import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";            // ← ADD this import
import "./ImageModal.css";

const overlayVariants = {
  hidden: { backgroundColor: "rgba(0,0,0,0)" },
  shown : { backgroundColor: "rgba(0,0,0,0.85)", transition: { duration: 0.25 } },
  exit  : { backgroundColor: "rgba(0,0,0,0)",      transition: { duration: 0.25 } },
};

export default function ImageModal({
  open,
  onClose,
  src,
  alt,
  caption,
  link,                 // ← ADD link prop
}) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="modal-overlay"
          variants={overlayVariants}
          initial="hidden"
          animate="shown"
          exit="exit"
          onClick={onClose}
        >
          <motion.div
            className="modal-content"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ type: "spring", stiffness: 90, damping: 18 }}
            onClick={(e) => e.stopPropagation()}
          >
            <button className="modal-close" onClick={onClose}>✕</button>

            <img src={src} alt={alt} />
            <p>{caption}</p>

            {link && (
              <Link to={link} className="modal-cta">
                View project →
              </Link>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
